import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  sectionTitle = 'Admin Dashboard'
  adminDashboardNav = [
    { 
      onclick: "openPage('adminDashboardKey', this)",
      fa: 'fa fa-2x fas fa-chart-bar'
    },
    { 
      onclick: "openPage('adminDashboardUsers', this)",
      fa: 'fa fa-2x fas fa-users'
    },
    { 
      onclick: "openPage('adminDashboardDelegates', this)",
      fa: 'fa fa-2x fas fa-archway' 
    },
    { 
      onclick: "openPage('adminDashboardEvents', this)",
      fa: 'fa fa-2x fas fa-search' 
    },
    { 
      onclick: "openPage('adminDashboardPerformance', this)",
      fa: 'fa fa-2x fas fa-tachometer-alt' 
    },
    { 
      onclick: "openPage('adminDashboardRights', this)",
      fa: 'fa fa-2x fas fa-list-alt' 
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}
